import {Component} from 'react';

import ReactDOM from 'react-dom';

import {createLogger} from '~/shared/logging';

const logger = createLogger('Portal');

class Portal extends Component {
  componentDidMount() {
    this.root = document.getElementById('modals');
    if (!this.root) {
      logger.error('[Portal] #modals element missing — modal cannot mount');
      return;
    }
    this.el = document.createElement('div');
    this.el.style.cssText = 'position: fixed';
    this.root.appendChild(this.el);
    this.forceUpdate();
  }

  componentWillUnmount() {
    if (this.root && this.el) {
      this.root.removeChild(this.el);
    }
  }

  render() {
    if (this.el === undefined) {
      return null;
    }

    const {children} = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

export default Portal;
